module.exports = __webpack_public_path__ + "static/media/cockroach.51e4bfad.mp4";